import React from "react";
// import Icons from "../../Components/Icons/Icons";
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import ToolTipWrapper from "../../hoc/Wrp/ToolTipWrapper";
import Wrp from "../../hoc/Wrp/Wrp";
// import $ from "jquery";
import FilterToggle from './FilterToggle';

const Conditions = (props) => {
	//console.log('props.showFilterOpen===',props.showFilterOpen)
	return(
		<Wrp>
			<div className={(props.showFilterOpen===true)?'filterTemp open':'filterTemp'}>
				{
					props.showFilterOpen === true?
					<FilterToggle {...props} />
					:
					null
				}
				</div>
		</Wrp>
	)
}

export default Conditions;